/*
 * wb-sticky-atc.js -- product template only (loaded from sections/main-product.liquid).
 *
 * Two small behaviours from the 2026-09-02 audit:
 *
 *  1. Sticky buy bar (UX M8). After roughly 900px of scroll the add-to-cart button is off
 *     screen -- on mobile permanently, since Dawn's sticky info column is desktop only.
 *     An IntersectionObserver on the real button reveals #wb-sticky-atc when it leaves the
 *     viewport. The bar owns no form: its button carries form="product-form-<section>", so
 *     the browser submits the SAME form and <product-form> handles it unchanged.
 *
 *  2. "Added" confirmation (item 6). Dawn spins the button but never confirms, so a
 *     successful add reads as nothing happening. Subscribing to PUB_SUB_EVENTS.cartUpdate
 *     picks up adds from the main button, the sticky button and quick-add alike.
 */
(function () {
  const ADDED_MS = 2000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const bar = document.querySelector('[data-wb-sticky-atc]');
    const mainButton = document.querySelector('.product-form__submit');

    /* --- 1. sticky bar --- */
    if (bar && mainButton) {
      bar.hidden = false;
      // Scroll fallback: IntersectionObserver is throttled or silent in background /
      // hidden documents and on some low-power browsers, so the position check also
      // runs on scroll (rAF-throttled). Both paths set the same class.
      function check() {
        bar.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom < 0);
      }
      let queued = false;
      window.addEventListener(
        'scroll',
        function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            check();
          });
        },
        { passive: true }
      );
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            });
          },
          { threshold: 0 }
        ).observe(mainButton);
      }
      check();
    }

    /* --- 2. "Added" on the add-to-cart buttons --- */
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    const addedText = (window.variantStrings && window.variantStrings.added) || 'Added';

    function flash(button) {
      if (!button || button.dataset.wbFlashing) return;
      // The label is a <span> in Dawn's button; fall back to the button itself.
      const label = button.querySelector('span:not(.loading__spinner):not(.sold-out-message)') || button;
      const original = label.textContent;
      button.dataset.wbFlashing = 'true';
      label.textContent = addedText;
      button.classList.add('wb-atc--added');
      setTimeout(function () {
        label.textContent = original;
        button.classList.remove('wb-atc--added');
        delete button.dataset.wbFlashing;
      }, ADDED_MS);
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      document.querySelectorAll('.product-form__submit, .wb-sticky-atc__button').forEach(flash);
    });
  });
})();
